<template>
    <div class="app-container-empty">
        <el-row>
            <el-col :style="{width:'calc(50% - 5px)'}">
                <el-card class="sitemapCard">
                    <div slot="header" class="cardHeader">
                        <el-row>
                            <el-col :span="16">
                                <el-button type="primary" icon="el-icon-plus" size="small" @click="createRootNode()">
                                    {{$t('sitemap.addRootSitemap') }}
                                </el-button>
                            </el-col>
                            <el-col :span="8">
                                <el-input clearable :placeholder="$t('commons.searchPhrase')"
                                          maxlength="50"
                                          v-model="filterText">
                                </el-input>
                            </el-col>
                        </el-row>
                    </div>
                    <div>
                        <el-tree
                                v-loading="loading"
                                :data="data"
                                node-key="id"
                                @node-drag-end="handleDragEnd"
                                :highlight-current="true"
                                draggable
                                :allow-drop="allowDrop"
                                :filter-node-method="filterNode"
                                :expand-on-click-node="false"
                                ref="tree">
                    <span class="custom-tree-node" slot-scope="{ node, data }"
                          @mouseenter="mouseoverNode(node)"
                          @mouseleave="mouseoutNode(node)">
                        <span @click="clickNode(node,data)">{{ node.label }}</span>
                        <template v-if="node.data.show">
                            <span>
                              <el-button
                                      :style="{ marginLeft:'20px' }"
                                      type="text"
                                      @click="() => appendNode(node)">
                                <i class="el-icon-circle-plus-outline"></i>
                              </el-button>
                              <el-button
                                      type="text"
                                      @click="() => removeNode(node, data)">
                                <i class="el-icon-delete"></i>
                              </el-button>
                            </span>
                        </template>
                    </span>
                        </el-tree>
                    </div>
                </el-card>
            </el-col>
            <el-col :style="{width:'calc(50% - 5px)',marginLeft:'10px'}">
                <el-card class="sitemapCard">
                    <el-form label-position="top" :model="sitemaps.form" ref="sitemapForm" :rules="sitemaps.formRule">
                        <el-form-item :label="$t('sitemap.userAccounts')" prop="userAccounts">
                            <el-select v-model="sitemaps.form.userAccounts" multiple collapse-tags clearable style="width: 100%">
                                <el-option
                                        v-for="item in users.list"
                                        :key="item.userAccount"
                                        :label="item.userAccount"
                                        :value="item.userAccount">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="sitemapId" style="display: none;">
                            <el-input v-model="sitemaps.form.sitemapId"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('sitemap.name')" prop="displayText">
                            <el-input maxlength="33" :show-word-limit="true" v-model="sitemaps.form.displayText" autocomplete="off" clearable :placeholder="$t('commons.pleaseInput')"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('sitemap.href')" prop="href">
                            <el-input maxlength="650" :show-word-limit="true" v-model="sitemaps.form.href" autocomplete="off" clearable :placeholder="$t('commons.pleaseInput')"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('sitemap.permission')" prop="permissionCode">
                            <el-cascader
                                    style="width: 100%"
                                    v-model="sitemaps.form.permissionCode"
                                    clearable
                                    :placeholder="$t('commons.selectPlease')"
                                    :options="permissionOptions">
                            </el-cascader>
                        </el-form-item>
                        <el-form-item :label="$t('sitemap.icon')" prop="icon">
                            <el-autocomplete
                                    clearable
                                    style="width: 100%"
                                    v-model="sitemaps.form.icon"
                                    :fetch-suggestions="queryIcon"
                                    @select="handleIconSelect($event)"
                                    :placeholder="$t('commons.selectPlease')">
                                <template slot-scope="{ item }">
                                    <div>
                                        <svg-icon style="width: 14px;height: 14px;margin-right: 6px;" :icon-class="item.itemCode" /> {{ item.itemName }}
                                        <span style="float: right; color: #8492a6; font-size: 13px">{{ item.itemCode }}</span>
                                    </div>
                                </template>
                            </el-autocomplete>
                        </el-form-item>
                        <el-form-item :label="$t('sitemap.policy')" prop="policyId">
                            <el-select v-model="sitemaps.form.policyId" clearable style="width: 100%">
                                <el-option
                                        v-for="(item,key) in policyOptions"
                                        :key="key"
                                        :label="item"
                                        :value="key">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="parentId" style="display: none;">
                            <el-input v-model="sitemaps.form.parentId"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('sitemap.parentLevel')" prop="parentText" style="display: none;">
                            <el-input v-model="sitemaps.form.parentText" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('commons.status')" prop="status">
                            <el-select v-model="sitemaps.form.status" style="width: 100%">
                                <el-option
                                        v-for="(item,key) in statusOptions"
                                        :key="key"
                                        :label="item"
                                        :value="key">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="nodeLevel" style="display: none;">
                            <el-input v-model="sitemaps.form.nodeLevel"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="saveSiteMap()">
                                {{$t('commons.save') }}
                            </el-button>
                        </el-form-item>
                    </el-form>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    let manager = require("@/api/iori/tenant.js")
    import {
        getSiteMapZtreeList,
        updateSiteMapNode,
        createSiteMap,
        updateSiteMap,
        deleteSiteMap,
        findIconCodeList
    } from '@/api/iori/sitemap'
    import {getAllPermission} from '@/api/iori/permission'
    import {generateTitle} from '@/utils/i18n'
    import {permissionStructTree} from '@/utils/tree'

    export default {
        name: 'SiteMap',
        watch: {
            filterText(val) {
                this.$refs.tree.filter(val);
            },
            // 切换语言重新设置快捷选项
            language: function () {
                this.recursiveAttr(this.data)
            },
        },
        data() {
            return {
                loading: true,
                filterText: '',
                data: [],
                treeRootId: -1,
                iconOptions: [],
                userAccountList: [],
                permissionOptions: [],
                defaultProps: {
                    children: 'children',
                    label: 'label',
                    show: 'show'
                },
                policyOptions: {
                    "1": this.$t("sitemap.sonShow"),
                    "2": this.$t("sitemap.everShow"),
                    "3": this.$t("sitemap.tenantShow"),
                    "4": this.$t("sitemap.platformShow"),
                },
                statusOptions: {
                    "1": this.$t("commons.active"),
                    "0": this.$t("commons.unActive")
                },
                sitemaps: {
                    show: false,
                    label: null,
                    children: null,
                    nodes: null,
                    id: null,
                    form: {
                        sitemapId: null,
                        userAccounts: null,
                        displayText: null,
                        href: null,
                        permissionCode: null,
                        icon: null,
                        policyId: null,
                        status: '1',
                        parentText: this.$t("commons.empty"),
                        parentId: this.treeRootId,
                        nodeLevel: 1,
                        orderNo: 0,
                        show: false,
                        label: null,
                        children: null
                    },
                    formRule: {
                        displayText: [
                            {
                                required: true,
                                trigger: ['blur', 'change'],
                                message: this.$t('validate.required')
                            }]
                        ,
                        // href: [{
                        //     required: true,
                        //     trigger: ['blur', 'change'],
                        //     message: this.$t('validate.required')
                        // }],
                        status: [{
                            required: true,
                            trigger: ['blur', 'change'],
                            message: this.$t('validate.required')
                        }],
                    }
                },
                users: {
                    list: null,
                    listQuery: {
                        current: 1,
                        rowCount: 10,
                        tenantId: null,
                        userAccount: null
                    },
                },
            }
        },
        created() {
            this.getSiteMapZtreeList();
            this.getTenantUser();
        },
        computed: {
            language() {
                return this.$store.getters.language
            }
        },
        methods: {
            getTenantUser() {
                manager._tenant_getMountAccounts(this.users.listQuery).then(response => {
                    this.users.list = response.rows
                }).catch(error => {
                    console.log(`查询失败，原因 => ${error}`)
                })
            },
            filterNode(value, data) {
                if (!value) return true;
                return data.label.indexOf(value) !== -1;
            },
            getSiteMapZtreeList() {
                this.loading = true
                getSiteMapZtreeList({parentId: this.treeRootId}).then(response => {
                    this.recursiveAttr(response);
                    this.createRootNode();
                }).finally(() => {
                    this.loading = false;
                })

                //图标下拉框加载
                getAllPermission().then(resp => {
                    let cascadeList = null;
                    cascadeList = permissionStructTree(resp, this);

                    //将第三级的空子节点 children : []设置为 children : undefined
                    cascadeList.forEach(function (obj) {
                        obj.children.forEach(function (msg) {
                            msg.children.forEach(function (msg) {
                                msg.children = undefined;
                            })
                        })
                    })
                    this.permissionOptions = cascadeList;
                });
            },
            //递归修改属性及数据结构
            recursiveAttr(row) {
                let data = row.map(v => {
                    v.children = v.nodes;
                    v.label = generateTitle(v.displayText);
                    this.$set(v, 'status', v.status + '')
                    this.$set(v, 'policyId', v.policyId + '')
                    v.show = false;
                    v.id = v.sitemapId;
                    if (v.nodes != undefined) {
                        this.recursiveAttr(v.nodes);
                    }
                    return v
                })
                this.data = data;
            },
            //获取图标输入列表
            queryIcon(queryString, cb) {
                //图标下拉框加载
                findIconCodeList({"classifyCode": "sitemapIcon"}).then(response => {
                    this.iconOptions = response;
                    let iconOptions = this.iconOptions;
                    let results = queryString ? iconOptions.filter(this.createIconFilter(queryString)) : iconOptions;
                    // 调用 callback 返回建议列表的数据
                    cb(results);
                });
            },
            //过滤图标列表
            createIconFilter(queryString) {
                return (restaurant) => {
                    return (restaurant.itemCode.toLowerCase().indexOf(queryString.toLowerCase()) !== -1)
                        || (restaurant.itemName.toLowerCase().indexOf(queryString.toLowerCase()) !== -1);
                };
            },
            //修改图标属性值
            handleIconSelect(data) {
                this.sitemaps.form.icon = data.itemCode;
            },
            allowDrop() {
                return true;
            },
            handleDragEnd(draggingNode, dropNode, dropType) {
                if (dropType == "before") {
                    draggingNode.data.parentId = dropNode.data.parentId;
                    draggingNode.data.nodeLevel = dropNode.data.nodeLevel;
                    draggingNode.data.orderNo = dropNode.data.orderNo - 1;
                } else if (dropType == "after") {
                    draggingNode.data.parentId = dropNode.data.parentId;
                    draggingNode.data.nodeLevel = dropNode.data.nodeLevel;
                    draggingNode.data.orderNo = dropNode.data.orderNo + 1;
                } else if (dropType == "inner") {
                    draggingNode.data.parentId = dropNode.data.sitemapId;
                    draggingNode.data.nodeLevel = dropNode.data.nodeLevel + 1;
                    if (dropNode.data.nodes == undefined) {
                        draggingNode.data.orderNo = 1;
                    } else {
                        draggingNode.data.orderNo = dropNode.data.nodes.length + 1;
                    }
                } else if (dropType == "none") {
                    return;
                }
                updateSiteMapNode(draggingNode.data).then(() => {
                    this.clearForm();
                    // 成功提示
                    this.$message({
                        type: 'success',
                        message: this.$t('message.saveSuccess')
                    });
                }).catch(error => {
                    console.log(`保存失败，原因 => ${error}`)
                })
            },
            appendNode(node) {
                this.clearForm();
                this.sitemaps.form.parentId = node.data.sitemapId;
                this.sitemaps.form.parentText = generateTitle(node.data.displayText);
                this.sitemaps.form.nodeLevel = node.data.nodeLevel + 1;
                if (node.data.nodes == undefined) {
                    this.sitemaps.form.orderNo = 1;
                } else {
                    this.sitemaps.form.orderNo = node.data.nodes.length + 1;
                }
            },
            createRootNode() {
                this.clearForm();
                this.sitemaps.form.orderNo = this.data[this.data.length - 1].orderNo + 1;
            },
            saveSiteMap() {
                this.$refs.sitemapForm.validate((valid) => {
                    if (Array.isArray(this.sitemaps.form.permissionCode)) {
                        this.sitemaps.form.permissionCode = this.sitemaps.form.permissionCode[2];
                    }
                    if (valid) {
                        this.sitemaps.form.userAccounts = this.sitemaps.form.userAccounts !== null ? this.sitemaps.form.userAccounts.join(",") : null
                        //未点击添加主菜单直接保存时，取最大orderNo
                        if (this.sitemaps.form.sitemapId == null) {
                            this.sitemaps.form.orderNo = this.data[this.data.length - 1].orderNo + 1;
                        }
                        if (this.sitemaps.form.sitemapId != null) {
                            updateSiteMap(this.sitemaps.form).then(() => {
                                this.updateTreeNode()
                                // 成功提示
                                this.$message({
                                    type: 'success',
                                    message: this.$t('message.saveSuccess')
                                });
                            }).catch(error => {
                                console.log(`保存失败，原因 => ${error}`)
                            })
                        } else {
                            createSiteMap(this.sitemaps.form).then((node) => {
                                this.createSonNode(node);
                                if (node.parentId == this.treeRootId) {
                                    this.data.push(node);
                                }
                                // 成功提示
                                this.$message({
                                    type: 'success',
                                    message: this.$t('message.saveSuccess')
                                });
                            }).catch(error => {
                                console.log(`保存失败，原因 => ${error}`)
                            })
                        }
                        this.sitemaps.form.userAccounts = this.sitemaps.form.userAccounts.join(",")
                    }
                });
            },
            removeNode(node, data) {
                if (node.isLeaf) {
                    this.$confirm(this.$t('message.deleteConfirm'), this.$t('commons.warning'), {
                        confirmButtonText: this.$t('commons.confirm'),
                        cancelButtonText: this.$t('commons.cancel'),
                        type: 'warning'
                    }).then(() => {
                        deleteSiteMap({"sitemapId": data.sitemapId}).then(() => {
                            // 成功提示
                            this.$message({
                                type: 'success',
                                message: this.$t('message.deleteSuccess')
                            });
                            //异步更新
                            const parent = node.parent;
                            const children = parent.data.children || parent.data;
                            const index = children.findIndex(d => d.id === data.id);
                            children.splice(index, 1);

                        }).catch(error => {
                            console.log(`未删除，原因 => ${error}`)
                        })
                    }).catch(error => {
                        console.log(`未删除，原因 => ${error}`)
                    });
                } else {
                    // 失败提示
                    this.$message({
                        type: 'info',
                        message: "有子节点，不可删除"
                    });
                }
            },
            mouseoverNode(node) {
                node.data.show = true;
            },
            mouseoutNode(node) {
                node.data.show = false;
            },
            clickNode(node, data) {
                this.sitemaps.form.sitemapId = data.sitemapId;
                this.sitemaps.form.displayText = data.displayText;
                this.sitemaps.form.href = data.href;
                this.sitemaps.form.userAccounts = data.userAccounts.split(",");
                if (data.permissionCode) {
                    this.sitemaps.form.permissionCode = [undefined, undefined, data.permissionCode];
                } else {
                    this.sitemaps.form.permissionCode = null;
                }
                this.sitemaps.form.icon = data.icon;
                if (data.policyId != 'null') {
                    this.sitemaps.form.policyId = data.policyId;
                } else {
                    this.sitemaps.form.policyId = '';
                }
                this.sitemaps.form.status = data.status;
                this.sitemaps.form.parentId = data.parentId;
                if (this.sitemaps.form.parentId == this.treeRootId) {
                    this.sitemaps.form.parentText = this.$t("commons.empty");
                } else {
                    this.sitemaps.form.parentText = generateTitle(node.parent.data.displayText);
                }
                this.sitemaps.form.nodeLevel = data.nodeLevel;
                this.sitemaps.form.orderNo = data.orderNo;
            },
            clearForm() {
                this.sitemaps.form.sitemapId = null;
                this.sitemaps.form.displayText = null;
                this.sitemaps.form.href = null;
                this.sitemaps.form.permissionCode = null;
                this.sitemaps.form.userAccounts = null;
                this.sitemaps.form.icon = null;
                this.sitemaps.form.policyId = null;
                this.sitemaps.form.status = '1';
                this.sitemaps.form.parentText = this.$t("commons.empty");
                this.sitemaps.form.parentId = this.treeRootId;
                this.sitemaps.form.nodeLevel = 1;
                this.sitemaps.form.orderNo = 0;
            },
            //节点数据更新
            updateTreeNode() {
                this.$refs.tree.getCurrentNode().sitemapId = this.sitemaps.form.sitemapId;
                this.$refs.tree.getCurrentNode().displayText = this.sitemaps.form.displayText;
                this.$refs.tree.getCurrentNode().href = this.sitemaps.form.href;
                this.$refs.tree.getCurrentNode().permissionCode = this.sitemaps.form.permissionCode;
                this.$refs.tree.getCurrentNode().icon = this.sitemaps.form.icon;
                this.$refs.tree.getCurrentNode().policyId = this.sitemaps.form.policyId;
                this.$refs.tree.getCurrentNode().userAccounts = this.sitemaps.form.userAccounts;
                this.$refs.tree.getCurrentNode().status = this.sitemaps.form.status;
                this.$refs.tree.getCurrentNode().parentText = this.sitemaps.form.parentText;
                this.$refs.tree.getCurrentNode().parentId = this.sitemaps.form.parentId;
                this.$refs.tree.getCurrentNode().nodeLevel = this.sitemaps.form.nodeLevel;
                this.$refs.tree.getCurrentNode().orderNo = this.sitemaps.form.orderNo;
                this.$refs.tree.getCurrentNode().label = generateTitle(this.sitemaps.form.displayText);
            },
            createSonNode(node) {
                node.id = node.sitemapId;
                node.show = false;
                node.children = null;
                node.label = generateTitle(node.displayText);
                if (node.parentId == this.treeRootId) {
                    node.parentText = this.$t("commons.empty");
                    node.children = [];
                } else {
                    this.$refs.tree.store.nodesMap[this.$refs.tree.getCurrentNode().id].expanded = true;
                    node.parentText = generateTitle(this.$refs.tree.getCurrentNode().displayText)
                    if (this.$refs.tree.getCurrentNode().children == null) {
                        this.$refs.tree.getCurrentNode().children = [];
                    }
                    this.$refs.tree.getCurrentNode().children.push(node)
                }

            }
        }
    }

</script>

<style scoped>
    .sitemapCard {
        height: calc(100vh - 90px);
    }

    .sitemapCard >>> .el-card__header {
        padding: 6px 10px;
    }

    .sitemapCard >>> .el-card__body {
        overflow-y: auto;
        height: calc(100%);
    }

    .sitemapCard >>> .el-tree {
        margin-bottom: 50px;
    }

    .cardHeader{
        line-height: 34px;
        font-weight: 600;
    }
</style>
